var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooter5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.8511,
    cy: 17.8511,
    r: 17.8511,
    fill: "#AAC528"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_315_718)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2176 16.4407C20.2284 15.2784 21.3717 14.6889 22.8172 14.7601C25.1688 14.8757 26.824 16.5128 26.943 19.0687C27.0474 21.3198 26.9733 23.5788 26.9894 25.8339C26.9933 26.375 26.7399 26.5772 26.2206 26.5641C25.5249 26.5466 24.8267 26.5305 24.1327 26.571C23.4442 26.6113 23.1824 26.3349 23.1942 25.6511C23.2213 24.1201 23.2046 22.588 23.2016 21.0564C23.2007 20.639 23.2059 20.2197 23.1732 19.8043C23.0727 18.5186 22.3182 17.7426 21.1997 17.7513C20.0501 17.7602 19.12 18.6841 19.0997 19.9133C19.0701 21.7228 19.0879 23.5331 19.0841 25.3431C19.0815 26.555 19.0805 26.555 17.8839 26.5629C15.2964 26.5795 15.2974 26.5795 15.2964 23.9914C15.2954 21.3461 15.3147 18.7001 15.2762 16.0554C15.265 15.2895 15.5211 14.9828 16.2847 15.0544C16.7263 15.0959 17.175 15.059 17.6208 15.0609C18.9508 15.0668 18.9508 15.0675 19.2176 16.4407ZM9.2702 20.7638C9.2702 19.1773 9.29931 17.59 9.2574 16.0048C9.23813 15.2634 9.52121 15.0067 10.2359 15.0508C10.9292 15.0932 11.6275 15.0747 12.3227 15.0599C12.845 15.0491 13.0811 15.2617 13.0792 15.801C13.0668 19.141 13.0651 22.4805 13.0716 25.8205C13.0726 26.3552 12.8414 26.5755 12.3156 26.5644C11.5645 26.5484 10.812 26.5425 10.0615 26.5674C9.48535 26.5866 9.26893 26.3404 9.27512 25.7734C9.2934 24.1036 9.28159 22.4334 9.28159 20.7636C9.27807 20.7638 9.27413 20.7638 9.2702 20.7638ZM11.135 13.4042C9.91328 13.399 9.00835 12.5576 9.00006 11.4191C8.99162 10.3 9.92565 9.42589 11.1301 9.42505C12.4407 9.42435 13.3284 10.2321 13.3232 11.4205C13.3175 12.6307 12.4583 13.4094 11.135 13.4042Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_315_718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter5);
export default __webpack_public_path__ + "static/media/Footer5.3ec6c24b9f24791a68612344d50bdb22.svg";
export { ForwardRef as ReactComponent };